/* global angular */
( function () {
	'use strict';

	function templateGraphPdf ( moment, pdfCommonFactory ) {
		function mapSections ( section ) {
			return {
				'id'    : 'graph',
				'stack' : [
					{
						'text'  : section.graphTitle || '',
						'style' : 'graphTitle'
					}, {
						'text'  : section.subtitle || '',
						'style' : 'graphSubtitle'
					}, {
						'image' : section.graphImage,
						'fit'   : [ 500, 300 ]
					}
				]
			};
		}

		function buildSectionGraph ( sectionArr ) {
			return sectionArr.map( mapSections );
		}

		function buildObservationGraph ( obsData ) {
			return [ {
				'stack' : [
					{
						'text'  : obsData.graphTitle,
						'style' : 'graphTitle'
					}, {
						'text'  : obsData.subtitle,
						'style' : 'graphSubtitle'
					}, {
						'image' : obsData.graphImage,
						'fit'   : [ 500, 300 ]
					}
				]
			} ];
		}

		function buildGraphReport ( data, template ) {
			function checkIfEvenAndHasNextItem ( item, index, array ) {
				return index % 2 === 1 && array[ index + 1 ];
			}

			function addPageBreak ( item ) {
				item.pageBreak = 'after';
			}

			function mapGroup ( group ) {
				return data.sections[ group.id ];
			}

			var stackArr = [
				buildObservationGraph( data.observation ),
				buildSectionGraph( ( ( template || {} ).groups || [] ).map( mapGroup ) )
			];

			var flatten = [].concat.apply( [], stackArr );

			flatten.filter( checkIfEvenAndHasNextItem ).forEach( addPageBreak );

			return {
				'stack' : stackArr
			};
		}

		function buildReport ( data, filters, template ) {
			var sections = {
				'pageBreak' : 'before',
				'stack'     : [
					pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2, [ 0, 0, 0, 0 ] ),
					buildGraphReport( data, template )
				]
			};

			return sections;
		}

		function buildTagFilters ( tags ) {
			return Object.keys( tags ).map( function ( key ) {
				return {
					'columns' : [
						{
							'text'  : key,
							'style' : 'frontPageHeaderKey',
							'width' : '25%'
						}, {
							'text'  : tags[ key ],
							'style' : 'frontPageHeaderValue',
							'width' : '75%'
						}
					]
				};
			} );
		}

		function generateFrontPageDetails ( filters ) {
			var section = {
				'stack' : [
					{
						'columns' : [
							{
								'text'      : 'Search Criteria',
								'width'     : '25%',
								'alignment' : 'right'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Template Name',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.templateName,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}

						]
					}, {
						'columns' : [
							{
								'text'  : 'Invitee',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.invitee,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range From',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.startDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range To',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.endDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'District',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.districts,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Location',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.locations,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Report Generated On',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( new Date() ).format( 'MM/DD/YY h:mm A' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Number Of Observations',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : String( filters.numberOfResults ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}
				]
			};

			section.stack.splice( 6, 0, buildTagFilters( filters.tags ) );

			return [].concat( [], section );
		}

		function generateFrontPage ( filters ) {
			var sections = {
				'stack' : [ pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2, [ 0, 0, 0, 0 ] ),
					generateFrontPageDetails( filters ) ]
			};

			return sections;
		}

		return {
			'generateFrontPage' : generateFrontPage,
			'buildReport'       : buildReport
		};
	}

	templateGraphPdf.$inject = [ 'moment', 'pdfCommonFactory' ];

	angular
		.module( 'app.components' )
		.factory( 'templateGraphPdf', templateGraphPdf );
} )();
